/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  block-scoped-var,
  eqeqeq,
  max-len,
  no-script-url,
  no-use-before-define,
  no-var,
  no-void,
  vars-on-top
*/
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from 'common/components/button';
import createReactClass from 'create-react-class';
import { ActionBar as ActionBarPropTypes } from './prop-types';

const OFFSET_MARGIN = 65;
const DEFAULT_STYLE = {
  top: 'auto',
  bottom: 0,
};

const ActionBar = createReactClass({

  propTypes: ActionBarPropTypes,

  //  ----  LIFECYCLE  ----------------------------------

  getDefaultProps() {
    return {
      canInsertEverywhere: true,
      disableButtons: false,
      continueInsteadOfInsert: false,
      onContinue: null,
    };
  },

  //  ----  BEHAVIOR  -----------------------------------

  insertSignature(insertEverywhere) {
    this.props.onInsert(insertEverywhere);
  },

  close() {
    this.props.onClose();
  },

  captureRef(node) {
    if (node) {
      this.node = node;
    }
  },

  getStyle() {
    const { topOffset } = this.props;

    // If no offset provided, use the default styles to fix the bar to the
    // bottom of the window
    if (!topOffset) {
      return DEFAULT_STYLE;
    }

    if (topOffset) {
      const windowHeight = window.innerHeight;
      const elemHeight = this.node
        ? this.node.clientHeight
        : 0;

      // If element will be pushed off the screen with this new offset,
      // then use the default style to fix to the bottom of the window
      // instead
      if (elemHeight + topOffset + OFFSET_MARGIN > windowHeight) {
        return DEFAULT_STYLE;
      }

      return {
        top: topOffset + OFFSET_MARGIN,
        bottom: 'auto',
      };
    }
  },

  //  ----  RENDERING  ----------------------------------

  render() {
    const style = this.getStyle();
    const buttons = [];
    const buttonProps = [
      {
        buttonId: 'insertButton',
        buttonColor: 'white',
        buttonHoverColor: this.props.isMobile ? 'white' : 'cerulean',
        buttonTextColor: 'cerulean',
        buttonHoverTextColor: this.props.isMobile ? 'cerulean' : 'white',
        className: this.props.disableButtons ? void 0 : 'whitelabel-secondary-button',
        buttonBorderColor: this.props.disableButtons ? 'cinder-block' : 'cerulean',
        disabled: this.props.disableButtons,
        intl: this.props.intl,
      },
      this.props.canInsertEverywhere ? {
        buttonId: 'insertEverywhereButton',
        buttonColor: 'cerulean',
        buttonTextColor: 'white',
        buttonHoverColor: this.props.isMobile ? 'cerulean' : null,
        buttonHoverTextColor: 'white',
        className: this.props.disableButtons ? void 0 : 'whitelabel-primary-button',
        buttonBorderColor: this.props.disableButtons ? 'cinder-block' : 'cerulean',
        disabled: this.props.disableButtons,
        intl: this.props.intl,
      } : void 0,
    ];

    const continueButtonProps = {
      buttonId: 'continueButton',
      buttonColor: 'cerulean',
      buttonTextColor: 'white',
      buttonHoverColor: this.props.isMobile ? 'cerulean' : null,
      buttonBorderColor: this.props.disableButtons ? 'cinder-block' : 'cerulean',
      buttonHoverTextColor: 'white',
      className: 'whitelabel-primary-button',
      intl: this.props.intl,
    };

    if (this.props.continueInsteadOfInsert) {

      buttons.push(
        (<Button
          key={'sign-modal-button-continue'}
          buttonText={this.props.intl.formatMessage({ id: 'signModal.actions.continue.labelText' }, { everywhere: i })}
          disabled={this.props.disableButtons}
          onClick={this.props.onContinue}
          {...continueButtonProps} />),
      );

    } else {

      // Normal insert buttons
      for (var i = 0; i < 2; i++) {
        if (buttonProps[i]) {
          var buttonText;
          if (i === 0 && !this.props.canInsertEverywhere && this.props.buttonText) {
            buttonText = this.props.buttonText;
          } else {
            buttonText = this.props.intl.formatMessage({ id: 'signModal.actions.insert.linkText' }, { everywhere: i });
          }
          buttons.push(
            (<Button
              key={`sign-modal-button-${i}`}
              buttonText={buttonText}
              onClick={this.props.disableButtons ? null : this.insertSignature.bind(null, (i === 1))}
              {...buttonProps[i]} />),
          );
        }
      }
    }

    let message = this.props.message;
    if (message == void 0) {
      // null = don't show a message
      message = (
        <FormattedMessage id='signModal.actions.legal.labelText' values={{ type: this.props.type }} />
      );
    }

    return (
      <div className='m-sign-modal--action-bar' style={style} ref={this.captureRef}>
        <div className='m-sign-modal--action-bar--inner'>
          <div className='m-sign-modal--action-bar--close-link m-sign-modal--action-bar--left'>
            <a href='javascript:;' onClick={this.close}>
              <span className='m-sign-modal--action-bar--close-link--arrow'></span>
              <span className='m-sign-modal--action-bar--close-link--text'>
                <FormattedMessage id='signModal.actions.back.linkText' />
              </span>
            </a>
          </div>
          <div className='m-sign-modal--action-bar--right'>
            <div className='m-sign-modal--action-bar--message'>{ message || '' }</div>
            <div className='m-sign-modal--action-bar--buttons'>
              { buttons }
            </div>
          </div>
        </div>
      </div>
    );
  },
});

module.exports = ActionBar;
